import MatchDetailsTeam from "./MatchDetailsTeam.jsx"

export default function MatchDetailsTeamA({match}) {
  const defaultBadgeThumb = "https://bolaodacopa.com/images/default_badge_thumb.png"

  return (
    <MatchDetailsTeam
      teamId={match.team_a_id}
      teamName={match.team_a_name}
      teamBadgeThumb={match.team_a_badge_thumb || defaultBadgeThumb}
      isWinner={match.is_ended && (match.team_a_score > match.team_b_score)}
      tournamentId={match.tournament_id}
    />
  )
}
